/* ========================================================================
    Module: Switch billing address placeholder
 ========================================================================== */
const switchBillingAddressPlaceholderOpinionExchangeMeeting = (): void => {
    const divisionElement = document.querySelector<HTMLSelectElement>(
        ".js-opinion-exchange-meeting-billing-address-division",
    );
    const billinAddressElement = document.querySelector<HTMLInputElement>(
        ".js-opinion-exchange-meeting-billing-address",
    );

    if (!divisionElement || !billinAddressElement) {
        return;
    }

    const billingName = "意見交換会参加請求書";

    switchPlaceholderText(divisionElement, billinAddressElement, billingName);

    divisionElement.addEventListener("change", (e) => {
        if (!(e.currentTarget instanceof HTMLSelectElement)) {
            return;
        }

        switchPlaceholderText(
            divisionElement,
            billinAddressElement,
            billingName,
        );
    });
};

const switchBillingAddressPlaceholder = (): void => {
    const divisionElement = document.querySelector<HTMLSelectElement>(
        ".js-billing-address-division",
    );
    const billinAddressElement = document.querySelector<HTMLInputElement>(
        ".js-billing-address",
    );

    if (!divisionElement || !billinAddressElement) {
        return;
    }

    const billingName = "カンファレンス参加費請求書";

    switchPlaceholderText(divisionElement, billinAddressElement, billingName);

    divisionElement.addEventListener("change", (e) => {
        if (!(e.currentTarget instanceof HTMLSelectElement)) {
            return;
        }

        switchPlaceholderText(
            divisionElement,
            billinAddressElement,
            billingName,
        );
    });
};

/**
 * target の placeholder を切り替える
 *
 * @param {HTMLSelectElement} element
 * @param {HTMLInputElement} target
 * @param {string} billingName
 * @returns {void}
 */
const switchPlaceholderText = (
    element: HTMLSelectElement,
    target: HTMLInputElement,
    billingName: string,
): void => {
    let placeholderText: string;

    switch (element.value) {
        case "1":
            placeholderText = `${billingName}の宛名（組織名／企業名）をご入力ください。`;
            break;
        case "2":
            placeholderText = `${billingName}の宛名（個人名）をご入力ください。`;
            break;
        default:
            placeholderText = `${billingName}の宛名をご入力ください。`;
    }

    target.placeholder = placeholderText;
};

export {
    switchBillingAddressPlaceholderOpinionExchangeMeeting,
    switchBillingAddressPlaceholder,
};
